import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BranchAndWithholdCommentService {

  constructor(private http: HttpClient) { }

  saveComments(
    baseUrl: string,
    returnClobSettingsObj: any,
    defaultsChangeDetails: any[],
    otherInfo: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=9q2et1`;

    // Build payload exactly like AngularJS BranchTaxFactory.saveComments
    // All saveJsonObject endpoints use application/x-www-form-urlencoded
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(defaultsChangeDetails) }, params);
    params = _.extend({ clob_settings: JSON.stringify(returnClobSettingsObj) }, params);
    params = _.extend({
      sso_id: otherInfo.sso_id,
      tax_year: otherInfo.tax_year,
      scenario: otherInfo.scenario,
      jcd_key: otherInfo.jcd_key,
      screen_key: otherInfo.screen_key,
      object_id: otherInfo.object_id,
      tag_key: otherInfo.tag_key,
      comments: otherInfo.comments,
      issue_key: otherInfo.issue_key,
      OPERATION_TYPE: otherInfo.OPERATION_TYPE
    }, params);
    
    // CRITICAL: Ensure object_id is always included (even if empty) to prevent NULL insert error
    if (!params.object_id) {
      params.object_id = otherInfo.object_id || 
                        returnClobSettingsObj.object_id || 
                        '';
    }

    // Convert to URLSearchParams for form-urlencoded format (like all other saveJsonObject services)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    // CRITICAL: Double-check that object_id is always included (even if empty) to prevent NULL insert error
    if (!urlEncoded.has('object_id')) {
      urlEncoded.set('object_id', params.object_id || otherInfo.object_id || returnClobSettingsObj.object_id || '');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

